import type { FC } from "react";

import classNames from "classnames";

import { useDispatch } from "@jti/store/reduxHooks";
import { hideError } from "@jti/store/slices/LEGACY__checkoutSlice";
import type { OrderException } from "@jti/store/types";
import { OrderExceptionCode } from "@jti/store/types";

import { MagentoOrderCreationErrorView } from "./MagentoOrderCreationErrorView";
import { PGSErrorView } from "./PGSErrorView";

import styles from "./OrderErrorView.module.scss";

type OrderErrorViewProps = {
  exception: OrderException | null;
  className?: string;
};

export const OrderErrorView: FC<OrderErrorViewProps> = ({ exception, className }) => {
  const dispatch = useDispatch();

  function getOrderErrorView({ code }: OrderException) {
    switch (code) {
      case OrderExceptionCode.PGSIssue:
        return <PGSErrorView />;

      case OrderExceptionCode.MagentoOrderCreationIssue:
        return <MagentoOrderCreationErrorView />;

      //unsupported exceptioon
      default:
        dispatch(hideError());
        throw Error("Unsupported exception type");
    }
  }

  if (exception === null) return <></>;

  try {
    const exceptionView = getOrderErrorView(exception);

    return <div className={classNames(styles.errorContainer, className)}>{exceptionView}</div>;
  } catch {
    return <></>;
  }
};
